/* tslint:disable */
/* eslint-disable */
/**
 * Stacks Blockchain API
 * Welcome to the API reference overview for the [Stacks Blockchain API](https://docs.hiro.so/stacks-blockchain-api).  [Download Postman collection](https://hirosystems.github.io/stacks-blockchain-api/collection.json) 
 *
 * The version of the OpenAPI document: STACKS_API_VERSION
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    RosettaAccount,
    RosettaAccountFromJSON,
    RosettaAccountFromJSONTyped,
    RosettaAccountToJSON,
    RosettaAmount,
    RosettaAmountFromJSON,
    RosettaAmountFromJSONTyped,
    RosettaAmountToJSON,
    RosettaCoinChange,
    RosettaCoinChangeFromJSON,
    RosettaCoinChangeFromJSONTyped,
    RosettaCoinChangeToJSON,
    RosettaOperationIdentifier,
    RosettaOperationIdentifierFromJSON,
    RosettaOperationIdentifierFromJSONTyped,
    RosettaOperationIdentifierToJSON,
    RosettaRelatedOperation,
    RosettaRelatedOperationFromJSON,
    RosettaRelatedOperationFromJSONTyped,
    RosettaRelatedOperationToJSON,
} from './';

/**
 * Operations contain all balance-changing information within a transaction. They are always one-sided (only affect 1 AccountIdentifier) and can succeed or fail independently from a Transaction.
 * @export
 * @interface RosettaOperation
 */
export interface RosettaOperation {
    /**
     * 
     * @type {RosettaOperationIdentifier}
     * @memberof RosettaOperation
     */
    operation_identifier: RosettaOperationIdentifier;
    /**
     * Restrict referenced related_operations to identifier indexes < the current operation_identifier.index. This ensures there exists a clear DAG-structure of relations. Since operations are one-sided, one could imagine relating operations in a single transfer or linking operations in a call tree.
     * @type {Array<RosettaRelatedOperation>}
     * @memberof RosettaOperation
     */
    related_operations?: Array<RosettaRelatedOperation>;
    /**
     * The network-specific type of the operation. Ensure that any type that can be returned here is also specified in the NetworkStatus. This can be very useful to downstream consumers that parse all block data.
     * @type {string}
     * @memberof RosettaOperation
     */
    type: string;
    /**
     * The network-specific status of the operation. Status is not defined on the transaction object because blockchains with smart contracts may have transactions that partially apply. Blockchains with atomic transactions (all operations succeed or all operations fail) will have the same status for each operation.
     * @type {string}
     * @memberof RosettaOperation
     */
    status?: string;
    /**
     * 
     * @type {RosettaAccount}
     * @memberof RosettaOperation
     */
    account?: RosettaAccount;
    /**
     * 
     * @type {RosettaAmount}
     * @memberof RosettaOperation
     */
    amount?: RosettaAmount;
    /**
     * 
     * @type {RosettaCoinChange}
     * @memberof RosettaOperation
     */
    coin_change?: RosettaCoinChange;
    /**
     * Operations Meta Data
     * @type {object}
     * @memberof RosettaOperation
     */
    metadata?: object;
}

export function RosettaOperationFromJSON(json: any): RosettaOperation {
    return RosettaOperationFromJSONTyped(json, false);
}

export function RosettaOperationFromJSONTyped(json: any, ignoreDiscriminator: boolean): RosettaOperation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'operation_identifier': RosettaOperationIdentifierFromJSON(json['operation_identifier']),
        'related_operations': !exists(json, 'related_operations') ? undefined : ((json['related_operations'] as Array<any>).map(RosettaRelatedOperationFromJSON)),
        'type': json['type'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'account': !exists(json, 'account') ? undefined : RosettaAccountFromJSON(json['account']),
        'amount': !exists(json, 'amount') ? undefined : RosettaAmountFromJSON(json['amount']),
        'coin_change': !exists(json, 'coin_change') ? undefined : RosettaCoinChangeFromJSON(json['coin_change']),
        'metadata': !exists(json, 'metadata') ? undefined : json['metadata'],
    };
}

export function RosettaOperationToJSON(value?: RosettaOperation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'operation_identifier': RosettaOperationIdentifierToJSON(value.operation_identifier),
        'related_operations': value.related_operations === undefined ? undefined : ((value.related_operations as Array<any>).map(RosettaRelatedOperationToJSON)),
        'type': value.type,
        'status': value.status,
        'account': RosettaAccountToJSON(value.account),
        'amount': RosettaAmountToJSON(value.amount),
        'coin_change': RosettaCoinChangeToJSON(value.coin_change),
        'metadata': value.metadata,
    };
}

